<template>
	<v-row class="mt-3" >
		<v-col>
			<v-card>
				<v-toolbar flat dark color="primary">
					<v-toolbar-title ><v-icon>fal fa-server fa-fw</v-icon> Worker #{{worker.id}}</v-toolbar-title>
					<v-spacer></v-spacer>
				</v-toolbar>
				<v-card-text>
					<v-row  >
						<v-col cols="6">
							<v-row   class="summary-grid">
								<v-col cols="3" class="label">Created</v-col>
								<v-col cols="9">{{formatDateTime(worker.created)}}</v-col>
								<v-col cols="3" class="label">Region</v-col>
								<v-col cols="9">{{worker.region}}</v-col>
								<v-col cols="3" class="label">LastHeartbeat</v-col>
								<v-col cols="9">{{formatDateTime(worker.lastHeartbeat)}}</v-col>
								<v-col cols="3" class="label">Status</v-col>
								<v-col cols="9" :class="statusClass">{{worker.status}} <span v-if="worker.offline">{{formatDateTime(worker.offline)}}</span></v-col>
							</v-row>
						</v-col>
						<v-col cols="6">
							<v-row   class="summary-grid">
								<v-col cols="3" class="label">Exe Hash</v-col>
								<v-col cols="9">{{worker.exeHash}}</v-col>
								<v-col cols="3" class="label">Exe Modified</v-col>
								<v-col cols="9">{{worker.exeModifiedDate}}</v-col>
								<v-col cols="3" class="label">Machine IP</v-col>
								<v-col cols="9">{{worker.machineIP}}</v-col>
								<v-col cols="3" class="label">Machine</v-col>
								<v-col cols="9">{{worker.machineName}}</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-col>
	</v-row>
</template>

<script>
export default {
	props: ["worker"],
	data() {
		return {};
	},
	computed: {
		statusClass() {
			return this.worker.status === "Unresponsive" ? "warning--text" : "";
		},
	},
	methods: {
	},
};
</script>
